// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customBorderRadius[data-v-0a2bb2ea]{border-radius:12px!important}", ""]);
// Exports
module.exports = exports;
